import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BrokenImageIcon from '@material-ui/icons/BrokenImage';
import ImageTag from '../ImageTag';

const ImageSet = ({ images, alt, className, defaultImage, isDefault, src, onError }) => {
  const [hasError, setError] = useState(false);

  const setErrorState = () => {
    setError(true);
    onError(true);
  };

  return isDefault ? (
    React.cloneElement(defaultImage, {
      className,
    })
  ) : (
    <>
      {!hasError && (
        <picture>
          <source srcSet={images?.large} onErrorCapture={setErrorState} media="(min-width: 1850px)" />
          <source srcSet={images?.medium} onErrorCapture={setErrorState} media="(min-width: 992px)" />
          <ImageTag
            src={images?.small || images?.original || src}
            alt={alt}
            className={className}
            onErrorCapture={setErrorState}
          />
        </picture>
      )}
      {hasError && <BrokenImageIcon className={className} />}
    </>
  );
};

ImageSet.propTypes = {
  images: PropTypes.shape({
    small: PropTypes.string,
    medium: PropTypes.string,
    large: PropTypes.string,
  }),
  alt: PropTypes.string,
  className: PropTypes.string,
  defaultImage: PropTypes.element,
  isDefault: PropTypes.bool,
  src: PropTypes.string,
  onError: PropTypes.func,
};

ImageSet.defaultProps = {
  alt: 'image',
  isDefault: false,
  images: {},
  src: '',
  onError: () => {},
};

export default ImageSet;
